import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const DownloadRequestsListHeader = ({ profile }) => {
  const intl = useIntl();

  return (
    <tr>
      {profile.is_admin && (
        <th>
          {intl.formatMessage({ defaultMessage: 'User' })}
        </th>
      )}
      <th className="request-date">
        {intl.formatMessage({ defaultMessage: 'Created' })}
      </th>
      <th className="request-collection">
        {intl.formatMessage({ defaultMessage: 'Collections' })}
      </th>
      <th className="request-files">
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      <th className="request-file-sizes">
        {intl.formatMessage({ defaultMessage: 'Sizes' })}
      </th>
      <th className="request-status">
        {intl.formatMessage({ defaultMessage: 'Status' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

DownloadRequestsListHeader.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default DownloadRequestsListHeader;
